import { render, staticRenderFns } from "./nuevaTarea.vue?vue&type=template&id=45457a28&"
import script from "./nuevaTarea.vue?vue&type=script&lang=js&"
export * from "./nuevaTarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports